import { NgModule }                     from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { UserflowInitializerComponent } from './userflow.initializer.component';

import { UserflowService } from './userflow.service';

@NgModule({
  declarations: [
    UserflowInitializerComponent
  ],
  entryComponents: [
    UserflowInitializerComponent
  ],
  exports: [
    UserflowInitializerComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    UserflowService
  ]
})
export class UserflowModule {}
